import React from 'react';
import { FileUploadAPIType, MatchedNodeType } from '../Response/Model';
import Axios from 'axios';
import { getFileSize } from '../Response/Utils';
import { getImg } from '../../../Utils/getImg';
import { TString } from '../Response/Utils';
interface Props {
  file: File;
  then: (status: boolean) => void;
}
const LAMBDA_URL =
  'https://8w4t9iyy40.execute-api.ap-south-1.amazonaws.com/v1/n';
function FileUploadStatus(props: Props & FileUploadAPIType & MatchedNodeType) {
  const [uploadProgress, setUploadProgress] = React.useState(0);

  const canvasRef: React.MutableRefObject<HTMLCanvasElement> = React.useRef(
    null
  );

  React.useEffect(() => {
    const formData = new FormData();
    formData.append('file', props.file);
    Axios.post(
      `${LAMBDA_URL}?taskId=${props.taskId}&workflowId=${props.workflowId}&botId=${props.botId}`,
      formData,
      {
        headers: { 'Content-Type': 'multipart/form-data' },
        onUploadProgress: progressEvent => {
          const { loaded, total } = progressEvent;
          setUploadProgress(Math.round((loaded * 100) / total));
        }
      }
    )
      .then(() => {
        props.then(true);
      })
      .catch(e => {
        props.then(false);
      });
  }, [props.file]);

  React.useEffect(() => {
    if (uploadProgress >= 1 && uploadProgress < 100) {
      /**
       * Scale Up from (0 to 100) to (0 to 360)
       */
      const scaledUpValue = (uploadProgress * 360) / 100;
      /**
       * Convert to radian
       */
      const radian = (Math.PI * scaledUpValue) / 180;
      /**
       * Calculate arc end angle
       */

      const ctx = canvasRef.current.getContext('2d');
      ctx.clearRect(0, 0, 20, 20);
      ctx.beginPath();
      ctx.arc(10, 10, 8, 0, radian);
      ctx.strokeStyle = '#259a36';
      ctx.lineWidth = 2;
      ctx.stroke();
    }
  }, [uploadProgress]);
  const extension = React.useMemo(() => props.file.name.split('.').pop(), [
    props.file.name
  ]);
  return (
    <div className="sf-fileupload-status-w">
      <div style={{ display: 'flex' }}>
        <div style={{ position: 'relative', marginRight: '12px' }}>
          <div className="file-upload-extension-icon">{extension}</div>
          <img
            src={getImg('icons/file-type.svg')}
            alt={TString({ labelName: 'uploadFileLabel' })}
          />
        </div>
        <div>
          <div title={props.file.name}>{props.file.name}</div>
          <div>{getFileSize(props.file.size)}</div>
        </div>
      </div>

      <div>
        {uploadProgress === 100 ? (
          <img
            src={getImg('icons/check_circle.svg')}
            alt={TString({ labelName: 'fileUploadedSuccessfullyLabel' })}
          />
        ) : null}
        {uploadProgress >= 1 && uploadProgress < 100 ? (
          <div className="sf-fileupload-loader">
            <canvas ref={canvasRef} width="20" height="20"></canvas>
            <img
              alt={TString({ labelName: 'cancelUploadLabel' })}
              src={getImg('icons/stop.svg')}
              style={{ cursor: 'pointer', zIndex: 1 }}
              onClick={() => {
                props.then(false);
              }}
            />
          </div>
        ) : null}
      </div>
    </div>
  );
}
export default FileUploadStatus;
